export default defineNuxtRouteMiddleware(() => {
	return navigateTo('/');
});
